import React from 'react';
import '../../stylings/darklightmode.css';

const Header = () => {
    return <header className="header" />;
};

export default Header;
